import { Component, computed, effect, inject, input, linkedSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LivrablePrincipal } from '@shared/models/livrable-principal.enum';
import { CanEditService } from '@shared/services/can-edit.service';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmTabsImports } from '@spartan-ng/helm/tabs';

import { ReferentielStore } from '../../administration/gestion-référentiels/store/referentiel.store';
import { Cartographie } from '../../cartographie/models/cartographie.model';

import { ChipComponent } from '@shared/components/chip/chip.component';
import { EstVerrouilleService } from '@shared/services/est-verrouille.service';
import { PerimetreCaracteristiquesComponent } from './perimetre-caracteristiques/perimetre-caracteristiques.component';
import { PerimetreMetierComponent } from './perimetre-metier/perimetre-metier.component';
import { FamilleLivrablesStore } from './perimetre-metier/store/famille-livrables.store';
import { LivrableStore } from './perimetre-metier/store/livrable.store';

@Component({
  selector: 'app-referentiel-metier-perimetre',
  imports: [
    HlmButtonImports,
    HlmTabsImports,
    RouterModule,
    HlmCardImports,
    PerimetreMetierComponent,
    PerimetreCaracteristiquesComponent,
    ChipComponent,
  ],
  templateUrl: './référentiel-métier-périmètre.component.html',
})
export class RéférentielMétierPérimètreComponent {
  readonly #familleStore = inject(FamilleLivrablesStore);
  readonly #livrableStore = inject(LivrableStore);
  readonly #referentielStore = inject(ReferentielStore);
  readonly #estVerrouilleService = inject(EstVerrouilleService);
  readonly #canEditService = inject(CanEditService);

  readonly cartographie = input.required<Cartographie>();
  readonly roles = input.required<string[]>();
  readonly referentiel = computed(() => this.#referentielStore.selectedEntity());

  peutModifier = computed(() =>
    this.#canEditService.check(
      this.referentiel()?.equipeResponsable,
      this.roles(),
      LivrablePrincipal.REFERENTIEL_METIER,
      this.cartographie(),
      this.referentiel(),
    ),
  );

  readonly estVerrouille = computed(() =>
    this.#estVerrouilleService.check(LivrablePrincipal.REFERENTIEL_METIER, this.cartographie(), this.referentiel()),
  );

  familles = linkedSignal(() => this.#familleStore.entities());
  livrables = linkedSignal(() => this.#livrableStore.entities());

  constructor() {
    effect(() => {
      const referentiel = this.referentiel();
      if (referentiel) {
        this.#familleStore.charger({
          idCartographie: this.cartographie().id,
          idRéférentiel: referentiel.id,
        });
        this.#livrableStore.charger(referentiel.id);
      }
    });
  }
}
